module.exports = __webpack_public_path__ + "img/11-Korea Newswire.c33eaf71.png";